import { useEffect } from 'react'

import { useNavigateToRootOnInvalidPath } from './useNavigateToRootOnInvalidPath'
import { useWorkspaceManagerContext } from './workspaceManagerContext'

export const WorkspaceValidator = () => {
  useNavigateToRootOnInvalidPath()
  const { currentWorkspaceKey, revalidateWorkspace } =
    useWorkspaceManagerContext()

  useEffect(() => {
    if (currentWorkspaceKey) {
      void revalidateWorkspace(currentWorkspaceKey)
    }
  }, [revalidateWorkspace, currentWorkspaceKey])

  return null
}
